"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPage on EditorialPage {\n    __typename\n    description\n    pageId\n    title\n    thumbnailUrl\n    themeTag\n    editorialLink: link {\n      relativeUrl\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialPageFragment = void 0;
var _fetching = require("@ori/fetching");
const editorialPageFragment = exports.editorialPageFragment = (0, _fetching.gql)(_templateObject());
